import { AlertCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

export default function Imprint() {
  const { t, language } = useLanguage();

  return (
    <div className="min-h-screen bg-cream-50 dark:bg-gray-900">
      {/* Header */}
      <div className="bg-primary-800 dark:bg-primary-900 py-12 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-display text-3xl md:text-4xl font-bold text-white">
            {t('imprint.title')}
          </h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
        {/* Demo Notice */}
        <div className="flex items-start gap-3 p-4 bg-amber-50 dark:bg-amber-900/20 rounded-lg border border-amber-200 dark:border-amber-800 mb-8">
          <AlertCircle className="w-5 h-5 text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
          <p className="text-amber-700 dark:text-amber-300">
            {t('imprint.demoNotice')}
          </p>
        </div>

        <div className="prose prose-lg dark:prose-invert max-w-none">
          {language === 'de' ? (
            <>
              <h2>{t('imprint.operator')}</h2>
              <p>
                Bella Vista (Demo-Restaurant)<br />
                Maximilianstraße 45<br />
                80539 München<br />
                Deutschland
              </p>

              <h2>{t('imprint.contact')}</h2>
              <p>
                Telefon: 089 - 987 654 32<br />
                E-Mail: info@bella-vista-muenchen.de
              </p>

              <h2>{t('imprint.legal')}</h2>
              <p>
                Dies ist eine Demo-Website, die zu Portfolio- und Demonstrationszwecken
                erstellt wurde. Das Unternehmen "Bella Vista" existiert nicht.
                Alle dargestellten Informationen, einschließlich Kontaktdaten,
                Speisekarten und Preise, sind fiktiv.
              </p>

              <h2>Erstellt von</h2>
              <p>
                Diese Demo-Website wurde erstellt von:<br />
                <a
                  href="https://fackelmeyer.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-accent-600 hover:text-accent-700 dark:text-accent-400"
                >
                  fackelmeyer.com
                </a>
              </p>

              <h2>Bildnachweise</h2>
              <p>
                Alle Bilder stammen von{' '}
                <a
                  href="https://unsplash.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-accent-600 hover:text-accent-700 dark:text-accent-400"
                >
                  Unsplash
                </a>
                {' '}und werden unter der Unsplash-Lizenz verwendet.
              </p>
            </>
          ) : (
            <>
              <h2>{t('imprint.operator')}</h2>
              <p>
                Bella Vista (Demo Restaurant)<br />
                Maximilianstraße 45<br />
                80539 Munich<br />
                Germany
              </p>

              <h2>{t('imprint.contact')}</h2>
              <p>
                Phone: 089 - 987 654 32<br />
                Email: info@bella-vista-muenchen.de
              </p>

              <h2>{t('imprint.legal')}</h2>
              <p>
                This is a demo website created for portfolio and demonstration purposes.
                The company "Bella Vista" does not exist. All information displayed,
                including contact details, menus, and prices, is fictional.
              </p>

              <h2>Created by</h2>
              <p>
                This demo website was created by:<br />
                <a
                  href="https://fackelmeyer.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-accent-600 hover:text-accent-700 dark:text-accent-400"
                >
                  fackelmeyer.com
                </a>
              </p>

              <h2>Image Credits</h2>
              <p>
                All images are from{' '}
                <a
                  href="https://unsplash.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-accent-600 hover:text-accent-700 dark:text-accent-400"
                >
                  Unsplash
                </a>
                {' '}and used under the Unsplash License.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
